
import {
  patchState,
  signalStoreFeature,
  type,
  withMethods,
} from '@ngrx/signals';
import {
  entityConfig,
  setAllEntities,
  withEntities,
} from '@ngrx/signals/entities';

import { OrganizationStudy } from '../../types';

const _organizationStudyEntityConfig = () =>
  entityConfig({
    collection: '_study',
    entity: type<OrganizationStudy>(),
    selectId: (entity) => entity.id,
  });

export const withOrganizationStudyEntities = () => {
  return signalStoreFeature(
    withEntities(_organizationStudyEntityConfig()),
    withMethods(({ ...store }) => ({
      loadStudies: (data: OrganizationStudy[]) => {
        return patchState(
          store,
          setAllEntities(data, _organizationStudyEntityConfig()),
        );
      },
    })),
  );
};
